import React from "react";

const TABLE_CLASS_NAME = "w-full border-collapse text-[13px] text-[#676a6c] font-[var(--font-family,Roboto,sans-serif)] last:mb-0 [&_th]:border [&_th]:border-[#c5c5c5] [&_td]:border [&_td]:border-[#c5c5c5] [&_tr]:border [&_tr]:border-[#c5c5c5] [&_th]:bg-[#f5f5f5] [&_th]:px-[6px] [&_th]:py-[4px] [&_th]:font-normal [&_th]:text-inherit [&_tr]:bg-[#f9f9f9] [&_tr]:h-[25px] [&_td]:bg-[#fff] [&_td]:px-[6px] [&_td]:py-[4px]";

const DashboardInfoTable = ({children, className = ""}) => (
    <table className={[TABLE_CLASS_NAME, className].filter(Boolean).join(" ")}>
        {children}
    </table>
);

const DashboardInfoTableTitle = ({children, colSpan = 5}) => (
    <tr>
        <th className="rounded-[5px] bg-[#efefef]! text-center font-normal! text-[18px]! text-[#4f4f4f]! uppercase" colSpan={colSpan}>{children}</th>
    </tr>
);

const DashboardInfoTableHead = ({children, colSpan = 1, className = ""}) => (
    <th colSpan={colSpan} className={["text-left font-normal! text-[13px]! text-[#4f4f4f]!", className].filter(Boolean).join(" ")}>
        {children}
    </th>
);

const DashboardInfoTableCell = ({children, colSpan = 1, className = ""}) => (
    <td colSpan={colSpan} className={["font-medium text-[#161616]!", className].filter(Boolean).join(" ")}>
        {children}
    </td>
);

export {DashboardInfoTableTitle, DashboardInfoTableHead, DashboardInfoTableCell};
export default DashboardInfoTable;
